"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SEGMENT = exports.CLAIM_SIZE = exports.CLAIM_FONT_TYPE = exports.CLAIM_COLOR = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

require("./claim.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CLAIM_SIZE = {
  REGULAR: 'regular',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
exports.CLAIM_SIZE = CLAIM_SIZE;
const CLAIM_FONT_TYPE = {
  REGULAR: 'regular',
  LIGHT: 'light',
  BOLD: 'bold',
  THIN: 'thin'
};
exports.CLAIM_FONT_TYPE = CLAIM_FONT_TYPE;
const CLAIM_COLOR = {
  NONE: '',
  TRANSPARENT: 'transparent',
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_7: 'grey7',
  GREY_6: 'grey6',
  GREY_5: 'grey5',
  GREY_5B: 'grey5b',
  GREY_4: 'grey4',
  GREY_4A: 'grey4a',
  GREY_3: 'grey3',
  GREY_2: 'grey2',
  GREY_1: 'grey1',
  GREY_1A: 'grey1a',
  GREY_A: 'greya',
  GREY_0: 'grey0',
  ORANGE: 'orange',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  BLUE: 'blue',
  BLUE_A: 'blue-a',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark',
  RED: 'red',
  RED_LIGHT: 'red-light',
  RED_DARK: 'red-dark',
  EGG: 'egg',
  EGG_LIGHT: 'egg-light',
  EGG_DARK: 'egg-dark'
};
exports.CLAIM_COLOR = CLAIM_COLOR;
const SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
/**
 * Stateless component to draw a claim
 * @param {string} bgColor background color of Claim
 * @param {string} label text that it shows
 * @param {string} segment type of Claim
 * @param {string} color text CLAIM_COLOR.
 * @param {string} className className to append to the component
 * @returns {JSX} Component JSX.
 */

exports.SEGMENT = SEGMENT;

const Claim = props => {
  const myProps = (0, _gerenciatdUtils2.setUpPropsByDevice)(props);
  let {
    borderColor
  } = myProps;
  const {
    bgColor,
    label,
    color,
    className,
    size,
    fontType,
    cySelector
  } = myProps;
  let segment = '';
  ({
    segment
  } = myProps);

  if (!borderColor) {
    borderColor = bgColor;
  }

  switch (segment) {
    case 'empresas':
    case 'emp':
      segment = 'emp';
      break;

    case 'particulares':
    default:
      segment = 'gp';
      break;
  }

  const sizeCss = ` claim_size--${size}`;
  const kindCss = ` claim_${segment}_bg--${bgColor}`;
  const colorCss = ` claim_${segment}_color--${color}`;
  const borderCss = ` claim_${segment}_border-color--${borderColor}`;
  const fontTypeCss = ` claim_${segment}--${fontType}`;
  const ownCss = className ? ` ${className}` : '';

  if (!label) {
    (0, _gerenciatdUtils.errorLog)('[Claim]: label must be !== null');
    return null;
  }

  const htmlLabel = {
    __html: label
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: `claim${sizeCss}${kindCss}${colorCss}${borderCss}${ownCss}${fontTypeCss}`,
    "cy-data": cySelector,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      dangerouslySetInnerHTML: htmlLabel
    })
  });
};

Claim.propTypes = {
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Definimos la altura de la banda claim",
   *  "kind": "both",
   *  "beautifulName": "Altura"
   * }
   */
  size: _propTypes.default.oneOf([CLAIM_SIZE.REGULAR, CLAIM_SIZE.SMALL, CLAIM_SIZE.XSMALL]),

  /**
   * {
   *  "info": "Color del borde del componente",
   *  "kind": "both",
   *  "beautifulName": "Color fondo"
   * }
   */
  borderColor: _propTypes.default.oneOf([CLAIM_COLOR.NONE, CLAIM_COLOR.BLACK, CLAIM_COLOR.WHITE, CLAIM_COLOR.GREEN, CLAIM_COLOR.GREEN_LIGHT, CLAIM_COLOR.GREEN_DARK, CLAIM_COLOR.COOL_GREY, CLAIM_COLOR.GREY_7, CLAIM_COLOR.GREY_6, CLAIM_COLOR.GREY_5, CLAIM_COLOR.GREY_5B, CLAIM_COLOR.GREY_4, CLAIM_COLOR.GREY_4A, CLAIM_COLOR.GREY_3, CLAIM_COLOR.GREY_2, CLAIM_COLOR.GREY_1, CLAIM_COLOR.GREY_1A, CLAIM_COLOR.GREY_A, CLAIM_COLOR.GREY_0, CLAIM_COLOR.ORANGE, CLAIM_COLOR.ORANGE_LIGHT, CLAIM_COLOR.ORANGE_DARK, CLAIM_COLOR.BLUE, CLAIM_COLOR.BLUE_A, CLAIM_COLOR.PURPLE, CLAIM_COLOR.PURPLE_LIGHT, CLAIM_COLOR.PURPLE_DARK, CLAIM_COLOR.PINK, CLAIM_COLOR.PINK_LIGHT, CLAIM_COLOR.PINK_DARK, CLAIM_COLOR.PIPPER, CLAIM_COLOR.PIPPER_LIGHT, CLAIM_COLOR.PIPPER_DARK, CLAIM_COLOR.RED, CLAIM_COLOR.RED_LIGHT, CLAIM_COLOR.RED_DARK]),

  /**
   * {
   *  "info": "Color de fondo para el contenedor del componente",
   *  "kind": "both",
   *  "beautifulName": "Color fondo"
   * }
   */
  bgColor: _propTypes.default.oneOf([CLAIM_COLOR.BLACK, CLAIM_COLOR.WHITE, CLAIM_COLOR.GREEN, CLAIM_COLOR.GREEN_LIGHT, CLAIM_COLOR.GREEN_DARK, CLAIM_COLOR.COOL_GREY, CLAIM_COLOR.GREY_7, CLAIM_COLOR.GREY_6, CLAIM_COLOR.GREY_5, CLAIM_COLOR.GREY_5B, CLAIM_COLOR.GREY_4, CLAIM_COLOR.GREY_4A, CLAIM_COLOR.GREY_3, CLAIM_COLOR.GREY_2, CLAIM_COLOR.GREY_1, CLAIM_COLOR.GREY_1A, CLAIM_COLOR.GREY_A, CLAIM_COLOR.GREY_0, CLAIM_COLOR.ORANGE, CLAIM_COLOR.ORANGE_LIGHT, CLAIM_COLOR.ORANGE_DARK, CLAIM_COLOR.BLUE, CLAIM_COLOR.BLUE_A, CLAIM_COLOR.PURPLE, CLAIM_COLOR.PURPLE_LIGHT, CLAIM_COLOR.PURPLE_DARK, CLAIM_COLOR.PINK, CLAIM_COLOR.PINK_LIGHT, CLAIM_COLOR.PINK_DARK, CLAIM_COLOR.PIPPER, CLAIM_COLOR.PIPPER_LIGHT, CLAIM_COLOR.PIPPER_DARK, CLAIM_COLOR.RED, CLAIM_COLOR.RED_LIGHT, CLAIM_COLOR.RED_DARK]),

  /**
   * {
   *  "info": "Color para el texto del componente",
   *  "kind": "both",
   *  "beautifulName": "Color texto"
   * }
   */
  color: _propTypes.default.oneOf([CLAIM_COLOR.BLACK, CLAIM_COLOR.WHITE, CLAIM_COLOR.GREEN, CLAIM_COLOR.GREEN_LIGHT, CLAIM_COLOR.GREEN_DARK, CLAIM_COLOR.COOL_GREY, CLAIM_COLOR.GREY_6, CLAIM_COLOR.GREY_5, CLAIM_COLOR.GREY_5B, CLAIM_COLOR.GREY_4, CLAIM_COLOR.GREY_4A, CLAIM_COLOR.GREY_3, CLAIM_COLOR.GREY_2, CLAIM_COLOR.GREY_1, CLAIM_COLOR.GREY_1A, CLAIM_COLOR.GREY_A, CLAIM_COLOR.GREY_0, CLAIM_COLOR.ORANGE, CLAIM_COLOR.ORANGE_LIGHT, CLAIM_COLOR.ORANGE_DARK, CLAIM_COLOR.BLUE, CLAIM_COLOR.BLUE_A, CLAIM_COLOR.PURPLE, CLAIM_COLOR.PURPLE_LIGHT, CLAIM_COLOR.PURPLE_DARK, CLAIM_COLOR.PINK, CLAIM_COLOR.PINK_LIGHT, CLAIM_COLOR.PINK_DARK, CLAIM_COLOR.PIPPER, CLAIM_COLOR.PIPPER_LIGHT, CLAIM_COLOR.PIPPER_DARK, CLAIM_COLOR.RED, CLAIM_COLOR.RED_LIGHT, CLAIM_COLOR.RED_DARK]),

  /**
   * {
   *  "info": "Fuente para el texto del componente",
   *  "kind": "both",
   *  "beautifulName": "Fuente texto"
   * }
   */
  fontType: _propTypes.default.oneOf([CLAIM_FONT_TYPE.REGULAR, CLAIM_FONT_TYPE.LIGHT, CLAIM_FONT_TYPE.BOLD, CLAIM_FONT_TYPE.THIN]),

  /**
   * {
   *  "info": "Texto que aparecerá dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  label: _propTypes.default.string.isRequired,

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.oneOf([SEGMENT.GP, SEGMENT.EMP])
};
Claim.defaultProps = {
  className: '',
  borderColor: CLAIM_COLOR.NONE,
  bgColor: CLAIM_COLOR.PURPLE,
  size: CLAIM_SIZE.REGULAR,
  color: CLAIM_COLOR.WHITE,
  fontType: CLAIM_FONT_TYPE.REGULAR,
  segment: SEGMENT.GP
};
var _default = Claim;
exports.default = _default;

//# sourceMappingURL=index.js.map